<template>
  <div class="file-column">
    <o-tooltip :label="value" multiline v-if="value">
      <div class="link is-link truncate" @click="handleShow">{{value}}</div>
    </o-tooltip>
  </div>
</template>

<script setup lang="ts">

import {toRefs} from "vue";
import type {OPRFile} from "@/models/OPRFile";

const props = withDefaults(defineProps<{
  row: OPRFile,
  value: string
}>(), {
});
const {
  row,
  value,
} = toRefs(props);

const emit = defineEmits<{
  'click': [OPRFile],
}>();

function handleShow() {
  emit('click', row.value);
}

</script>

<style scoped lang="scss">
    .file-column {
      max-width: 200px;

      .link {
        max-width: 200px;
      }
    }
</style>
